import UiLoading from './Loading';
import UiIndicatorMoomoo from '../indicator-moomoo';
import UiIndicatorMoomooDark from '../indicator-moomoo-dark';
import UiIndicatorNiuniu from '../indicator-niuniu';

UiLoading.install = function (Vue) {
  Vue.component(UiLoading.name, UiLoading);
  Vue.component(UiIndicatorMoomoo.name, UiIndicatorMoomoo);
  Vue.component(UiIndicatorMoomooDark.name, UiIndicatorMoomooDark);
  Vue.component(UiIndicatorNiuniu.name, UiIndicatorNiuniu);
};

export default UiLoading;